import cx from 'classnames';
import { memo } from 'react';

import DivTooltip from '@wg/wows-react-uikit/components/DivTooltip/DivTooltip';
import TooltipBody from '@wg/wows-react-uikit/components/Tooltip/TooltipBody';

import styles from './Table.scss';

interface TableHeadCellProps {
  children: React.ReactNode;
  modify: string;

  isSortable?: boolean;
  isActive?: boolean;
  isHidden?: boolean;

  tooltipParam?: string;
  tooltipText?: string;

  onClick?: () => void;
}

const TableHeadCell = ({
  children,
  modify,
  isSortable = false,
  isActive = false,
  isHidden = false,
  tooltipParam,
  tooltipText,
  onClick,
}: TableHeadCellProps) => {
  const classNameTh = cx(styles.th, styles[modify], {
    [styles.hide]: isHidden,
  });

  const classNameSorter = cx(styles.sorter, {
    [styles.isSortable]: isSortable,
    [styles.isActive]: isActive,
  });

  const hasTooltip = Boolean(tooltipText || tooltipParam);

  return (
    <div className={classNameTh}>
      <DivTooltip
        className={classNameSorter}
        onClick={onClick}
        tooltipBody={
          hasTooltip ? (
            <TooltipBody>
              {tooltipText ? <p dangerouslySetInnerHTML={{ __html: tooltipText }} /> : null}
              {tooltipParam ? <p dangerouslySetInnerHTML={{ __html: tooltipParam }} /> : null}
            </TooltipBody>
          ) : null
        }
      >
        {children}
      </DivTooltip>
    </div>
  );
};

export default memo(TableHeadCell);
